export const translationsPatientSurgeryState = {
  QUIZ_SEND: "Quiz enviado",
  QUIZ_ANSWERED: "Evaluación completa",
  SCHEDULED_ANESTHESIA: "",
  SCHEDULED_SURGERY: "",
  SCHEDULED_ASSESSMENT: "Valoración agendada",
  RESCHEDULED_ASSESSMENT: "Valoración reagendada",
  ASSESSMENT_MADE: "Valoración realizada",
  ASSESSMENT_MADE_RESCHEDULE: "Valoración realizada",
  QUIZ_SATISFACTION_ANSWERED: "Evaluación de satisfaccion completa",
  SCHEDULED_ASSESSMENT_FINAL: "Valoración final agendada",
  FINISHED: "Finalizado",
  ASSESSMENT_NO_SHOW: "No asiste a valoración",
};

export const PATIENTSURGERY_STATES = [
  { id: "QUIZ_SEND", label: "Quiz enviado" },
  { id: "QUIZ_ANSWERED", label: "Evaluación completa" },
  { id: "SCHEDULED_ASSESSMENT", label: "Valoración agendada" },
  { id: "RESCHEDULED_ASSESSMENT", label: "Valoración reagendada" },
  { id: "ASSESSMENT_MADE", label: "Valoración realizada" },
  { id: "ASSESSMENT_MADE_RESCHEDULE", label: "Valoración realizada" },
  {
    id: "QUIZ_SATISFACTION_ANSWERED",
    label: "Evaluación de satisfaccion completa",
  },
  { id: "SCHEDULED_ASSESSMENT_FINAL", label: "Valoración final agendada" },
  { id: "FINISHED", label: "Finalizado" },
  { id: "ASSESSMENT_NO_SHOW", label: "No asiste a valoración" },
];

export const translationClearanceStatuses = {
  YES: "Sí",
  NO: "No",
  NO_BUT_CAN_RESCHEDULE: "No, pero puede reagendar",
};
